import React 					from 'react';
import ReactDOM 			from 'react-dom';
import BLComponent		from '../core/_BLComponent.jsx';
import update 				from 'react-addons-update';
import Slider 				from 'react-slick';

import Preloader 			from '../common/_Preloader.jsx';
import GalleryCard 			from '../common/_GalleryCard.jsx';
import CommentsSection 		from '../common/_CommentsSection.jsx';
import CustomSelect 		from '../common/_CustomSelect.jsx';
import LikeButton 			from '../common/_LikeButton.jsx';
import {ColorWheel, AwardIcon}			from '../common/_Icons.jsx';
import {StudioAwards}			from './_StudioAwards.jsx';
import {StudioEvents}			from './_StudioEvents.jsx';
import PartListingItem		from '../common/_PartListingItem.jsx';
import GermanWarning		from '../common/_GermanWarning.jsx';
import {CustomAlert, onEscapePress, ClickShowTooltip}	from '../common/_Utilities.jsx';
import VideoContent from '../common/_VideoContent.jsx';

import AddToWantedListModal	from '../modals/_AddToWantedListModal.jsx';
import EasyBuyModal			from '../modals/_EasyBuyModal.jsx';
import ModelViewer 			from './_ModelViewer.jsx';
import EmptyState			from '../common/_EmptyState.jsx';
import DSAReportButton from '../common/_DSAReportButton.jsx';

export default class StudioModel extends BLComponent {
	constructor (props) {
		super(props);

		this.state = {
				likes: 				{liked: true, count: 0}
			,	detailView: 		0
			,	sortDirection: 		-1
			,	sort: 				0
			,	showModelViewer: 	false
			,	modelViewerMethod:	'steps'
			,	modelData: 			null
			,	filterColor: 		0
			,	showAddToWLModal: 	false
			,	showEasyBuyModal: 	false
			,	validModel:			true
			,	selectedTag:		null
			,	activeAward:		0
			};

		this.MViewerNotSupport = false;

		if(document.all && document.documentMode && 10 <= document.documentMode) {
			this.MViewerNotSupport = true
		}

		this._callbackRegistered	= null;
		this._historyPushed			= false;
		this._previousTitle			= document.title;

		this.slickSettings = {
			dots: false,
			arrows: false,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
			beforeChange: (current, next) => setTimeout(() => this.setState({activeAward: next}), 20),
		}
	}

	componentDidMount() {
		if(this.props.preview != null) {
			this.preview = true;
			this.setState({modelData: this.props.preview})
		}else{
			const	idModel		= this.props.idModel;
			const	urlInfo		= blapp.util.getUrlInfo(window.location.href);
			const	modelUrl	= blapp.util.getUrlInfo(blapp.url2.getStudioModelUrl(idModel));
			
			if(document.getElementsByClassName('js-hover-tooltip').length) {
				document.getElementsByClassName('js-hover-tooltip')[0].remove();
			}
		
			if(modelUrl.path != urlInfo.path) {
				this._historyPushed	= true;
				window.history.pushState( history.state + idModel, "Studio Model Design", blapp.url2.getStudioModelUrl( idModel ) );
				document.title	= "Studio Model Design";
				this.registerPopStateCallback( ( e ) => this.onPopState( e ) );
			}
			
			this.getModelData(idModel);
		}

		$('body').css('overflow', 'hidden');
	}

	componentWillUnmount() { 
		super.componentWillUnmount(); 
		$('body').css('overflow', 'auto');

		if(this._callbackRegistered != null) {
			blapp.personalized.unregisterCallback(this._callbackRegistered);
		}
	}

	componentDidUpdate() {
		this.initStickySidebar();
	}

	initStickySidebar() {
		const sidebar = this.meta;
		const content = this.content;

		if(sidebar) {
			const contentTop = content.offsetTop;

			function triggerStickySidebar() {
				const currentScroll = Math.round(document.querySelectorAll('.studio-model__container')[0].scrollTop);
				const navHeight = document.querySelectorAll('.header__internal')[0] ? document.querySelectorAll('.header__internal')[0].offsetHeight : 0;

				if(currentScroll + navHeight > contentTop) {
					sidebar.classList.add('studio-model__meta--sticky');
				}else if(currentScroll < contentTop) {
					sidebar.classList.remove('studio-model__meta--sticky');
				}
			}

			document.querySelectorAll('.studio-model__container')[0].addEventListener('scroll', triggerStickySidebar);
		}
	}

	render() {
		const modelInfo 	= this.state.modelData;
		const	func 		= {closeModal: this.closeModelViewerModal}
		const referer = this.props.referer;

		return (
			<div className="modal">
				{this.props.preview ? 
					<div className="studio-model-preview">
						<p className="studio-model-preview__label">Preview mode</p>
					</div> 
				: null}
				<div className={"studio-model__container main__content main__content--tight-mob faux-modal" + (this.state.showModelViewer ? ' overflow-hidden' : '')}>
					{this.state.validModel ?
						this.state.modelData ?
							<React.Fragment>
								{this.renderHeader()}
								<div ref={(content) => this.content = content} className="studio-model__internal faux-modal__internal">
									{this.state.showAddToWLModal ? this.addToWantedList() : null}
									{this.state.showEasyBuyModal ? this.renderEasyBuy() : null}
									{this.state.showModelViewer ? <ModelViewer viewType={this.state.modelViewerMethod} idModel={this.state.modelData.idModel} modelInfo={modelInfo} func={func}/> : null}
									{this.renderGallery()}
									{this.renderMeta()}
									{this.renderDetails()}
									{this.renderTags()}
									<GermanWarning classes="studio-model__german-warning l-margin-top--sm l-border--top"/>
									{this.renderComments()}
								</div>
							</React.Fragment>
						:
							<div className="studio-model__internal faux-modal__internal">
								<div className="center-preloader-container">
									<Preloader/>
								</div>
							</div>
					:	
						<div className="faux-modal__internal">
							<header className="studio-model__header">
								<div className="studio-model__header-image"/>
								<button className="studio-model__header-return" data-ts-name="studio-model__return-btn" onClick={() => this.closeModal()}>
									<i className="fas fa-chevron-left l-margin-right--sm"/>
									<div className="l-full-width">{referer ? `Back to ${referer}'s Profile` : 'Back to Studio Gallery'}</div>
								</button>
							</header>
							<div>
								<EmptyState type="scared" title={"Invalid model"} message={"Model was not found or you don't have access to it."}/>
							</div>
						</div>
					}
				</div>
			</div>
		);
	}

	renderHeader() {
		const modelData = this.state.modelData;
		const user 		= modelData.dmUserBuilder.dmUser;
		const state 	= blapp.country.getStateLegacy(user.idState);
		const referer = this.props.referer;
		const isOwner = blapp.session.getUserID() == this.state.modelData.dmUserBuilder.dmUser.idUser;
		let extraFlag = user.codeCountry == 'UK' && state;

		//statusModel == 0 = draft
		//statusModel == 1 = public
		//statusModel == 2 = private

		return (
			<header className="studio-model__header-container" style={{backgroundImage: `url(${modelData.dmMainImage ? modelData.dmMainImage.url : blapp.url2.getNoImageUrl()})`}}>
				<div className="studio-model__header">
					{isOwner && blapp.util.getUrlVar('ref') == 'my_studio' || isOwner && this.state.modelData.statusModel == 2 ? 
						<a className="studio-model__header-return" data-ts-name="studio-model__return-btn" href={blapp.url2.getStudioMyStudioUrl()}>
							<i className="fas fa-long-arrow-left l-margin-right--sm"/>
							<div className="l-full-width">Back to My Studio</div>
						</a>
					:
						this.preview ?
							<button className="studio-model__header-return" data-ts-name="studio-model__return-btn" onClick={() => this.props.close()}>
								<i className="fas fa-long-arrow-left l-margin-right--sm"/>
								<div className="l-full-width">{this.props.backButtonText ? this.props.backButtonText : 'Continue editing'}</div>
							</button>
						:
							<button className="studio-model__header-return" data-ts-name="studio-model__return-btn" onClick={() => this.closeModal()}>
								<i className="fas fa-long-arrow-left l-margin-right--sm"/>
								<div className="l-full-width">{referer ? `Back to ${referer}'s Profile` : 'Back to Studio Gallery'}</div>
							</button>
					}
					<div className="studio-model__header-title" data-ts-name="studio-model__name">{modelData.strModelName}</div>
					<div className="studio-model__publish-meta">
						<div className="studio-model__user-info l-flex l-center">
							<div className="studio-model__user-image">
								<div className="studio-model__user-image-content studio-model__user-image-content--large">
									<img className="studio-model__user-image-item" src={blapp.url2.getProfileImgUrl(user,'medium')}/>
								</div>
								<AwardIcon classes="studio-model__user-award" award={modelData.dmUserBuilder.stats.nTypeBadge} background/>
							</div>
							<div><a className="text--inherit" data-ts-name="studio-model__user-name" href={blapp.url2.getStudioPublicGalleryUrl(user.idUser)}>{user.skUsername}</a></div>
						</div>
						<div className="studio-model__user-country l-flex l-center" data-ts-name="studio-model__user-location">
							{extraFlag ? <img className="studio-model__user-country-flag" src={blapp.url.getCountryFlagSmallURL(state.idStateLegacy)}/> : null}
							<img className="studio-model__user-country-flag" src={blapp.url.getCountryFlagSmallURL(user.codeCountry)}/>
							{state && state.strStateName != null ? `${state.strStateName}, ` : null}{blapp.country.get(user.codeCountry).strCountryName}
						</div>
						{modelData.statusModel == 0 || !modelData.udtPublish ?
							<div className="studio-model__meta-published" data-ts-name="studio-model__model-published-date">
								<i className="fas fa-pen-ruler l-margin-right--sm"/>{`Draft created ${blapp.format.formatTimeElapsed(modelData.udtModified)}`}
							</div>
						:
							<div className="studio-model__meta-published" data-ts-name="studio-model__model-published-date">
								<i className="fas fa-calendar l-margin-right--sm"/>{`${$T("PUBLISHED")} ${blapp.format.formatTimeElapsed(modelData.udtPublish)}`}
							</div>
						}
					</div>
				</div>
			</header>
		);
	}

	renderGallery() {
		let images = null;

		if(this.preview && this.props.source != 'my_studio') {
			images = this.state.modelData.arrImages.map((image, key) => ({id: key, large: image.url, small: image.url}));
		}else{
			images = this.state.modelData.arrImages.map((image, key) => ({id: key, large: image.dmImage.url, small: image.dmThumbnail ? image.dmThumbnail.url : image.dmImage.url}));
		}

		return (
			<GalleryCard
				classes={'studio-model__gallery'}
				active={0}
				images={images}
				mode={1}
				hasBgColor={true}
				likeButton={{liked: this.state.likes.liked, count: this.state.likes.count, likeFunc: () => this.toggleLike()}}
			/>
		);
	}

	returnStatusType() {
		return {
			pendingModeration: this.state.modelData.nModerateAction == 0 && this.state.modelData.nPreviousAccess != 0
		,	hasFullAccess: !this.state.modelData.bDownloadable && this.state.modelData.bShowPartList
		,	hasFullAccessWithDownload: this.state.modelData.bDownloadable && this.state.modelData.bShowPartList
		,	isDisplayOnly: !this.state.modelData.bDownloadable && !this.state.modelData.bShowPartList
		,	isPrivate: this.state.modelData.statusModel == 2
		, isForcedPrivate: this.state.modelData.bForcedPrivate
		}
	}

	renderMeta() {
		const lots		= this.state.modelData.nLotsCnt;
		const items		= this.state.modelData.nItemsCnt;
		const colors	= this.state.modelData.nColorsCnt;
		const hasCustomParts = this.state.modelData.arrCustomParts.length > 0;

		const {pendingModeration, hasFullAccess, hasFullAccessWithDownload, isDisplayOnly} = this.returnStatusType();
		const isOwner = blapp.session.getUserID() == this.state.modelData.dmUserBuilder.dmUser.idUser;
		
		return (
			<div className="studio-model__meta-column">
				<section ref={(meta) => this.meta = meta} className={"studio-model__meta" + (blapp.config.isDesktopMode() ? ' studio-model__meta--desktop-mode' : '')}>
					{this.renderSharingStatus()}
					{this.renderAward()}
					<div className="studio-model__meta-block studio-model__meta-block--main">
						<section className="l-flex l-split studio-model__meta-item">
							<div className="text--center studio-model__meta-stat" data-ts-name="studio-model__meta--lot-cnt">
								<strong className="text--xl-title l-block l-margin-bottom--sm">{blapp.format.formatNumber(lots)}{hasCustomParts && <i className={`text--small fas fa-info-circle l-margin-left--sm js-has-tooltip js-top-left-tooltip`} data-tooltip={"The lot count includes custom parts"} data-tooltip-width={220} onClick={(e) => ClickShowTooltip(e)}/> }</strong>
								<small className="text--uppercase text-color--darkest80">
									{$T("LOTS")}
								</small>
							</div>
							<div className="text--center studio-model__meta-stat" data-ts-name="studio-model__meta--item-cnt">
								<strong className="text--xl-title l-block l-margin-bottom--sm">{blapp.format.formatNumber(items)}{hasCustomParts && <i className={`text--small fas fa-info-circle l-margin-left--sm js-has-tooltip js-center-tooltip`} data-tooltip={"The item count includes custom parts"} data-tooltip-width={220} onClick={(e) => ClickShowTooltip(e)}/> }</strong>
								<small className="text--uppercase text-color--darkest80">
									{$T("ITEMS")}
								</small>
							</div>
							<div className="text--center studio-model__meta-stat" data-ts-name="studio-model__meta--color-cnt">
								<strong className="text--xl-title l-block l-margin-bottom--sm">{blapp.format.formatNumber(colors)}{hasCustomParts && <i className={`text--small fas fa-info-circle l-margin-left--sm js-has-tooltip js-top-right-tooltip`} data-tooltip={"The color count includes custom parts"} data-tooltip-width={220} onClick={(e) => ClickShowTooltip(e)}/> }</strong>
								<small className="text--uppercase text-color--darkest80">
									{$T("COLORS")}
								</small>
							</div>
						</section>

						<section className="studio-model__meta-item text--small-title">
							{(((hasFullAccess || hasFullAccessWithDownload) && !pendingModeration) || isOwner) &&
								<button className="btn btn--cta-alt-studio l-full-width l-margin-bottom" data-ts-name="studio-model__meta-button--easy-buy" onClick={() => this.setState({showEasyBuyModal: true})}><i className="fas fa-wand-magic-sparkles fa-fw l-margin-right--sm"/>{$T("EASY_BUY")}</button>
							}
							{((hasFullAccessWithDownload && !pendingModeration) || isOwner) &&
								<button className="btn btn--cta btn--cta-studio l-full-width l-margin-bottom l-hide--small" data-ts-name="studio-model__meta-button--download" onClick={() => this.downloadModel()}><i className="fas fa-download fa-fw l-margin-right--sm"/>{$T("DOWNLOAD_FILE")}</button>
							}
							{(((hasFullAccess || hasFullAccessWithDownload) && !pendingModeration) || isOwner) &&
								<button className="btn l-full-width" data-ts-name="studio-model__meta-button--wanted-list" onClick={() => this.showWantedListModal()}><i className="far fa-fw fa-heart l-margin-right--sm"/>{$T("ADD_WANTED_LIST")}</button>
							}
							<LikeButton classes="l-full-width l-hide--desktop l-pad l-margin-top" likes={this.state.likes} onClickFunc={() => this.toggleLike()}/>
						</section>
						{(isOwner || (hasFullAccessWithDownload && !pendingModeration)) &&
							<section className="studio-model__meta-item studio-model__meta-item--footer">
								<button className="btn btn--link studio-model__meta-footer-link" data-ts-name="studio-model__meta-button--building-steps" onClick={() => this.triggerModelViewer('steps')}><i className="fas fa-fw fa-list-ol l-margin-right"/>View Instructions</button>
								<button className="btn btn--link studio-model__meta-footer-link" data-ts-name="studio-model__meta-button--3d-model" onClick={() => this.triggerModelViewer('model')}><i className="fas fa-fw fa-cube l-margin-right"/>View 3D Model</button>
							</section>
						}
					</div>

					<section className="studio-model__meta-block studio-model__meta-block--stats">
						<strong className="studio-model__meta-title studio-model__meta-title--stats">Stats</strong>
						<div className="studio-model__meta-stat-social" data-ts-name="studio-model__meta--views">
							<i className="far fa-fw fa-eye l-margin-right--sm"/>{blapp.format.formatNumber(this.state.modelData.nViewCnt)} views
						</div>
						{((!isDisplayOnly && !pendingModeration && hasFullAccessWithDownload) || isOwner) &&
							<div className="studio-model__meta-stat-social" data-ts-name="studio-model__meta--downloads">
								<i className="far fa-fw fa-download l-margin-right--sm"/>{blapp.format.formatNumber(this.state.modelData.nDownCnt)} downloads
							</div>
						}
						<div className="studio-model__meta-stat-social" data-ts-name="studio-model__meta--likes">
							<i className="far fa-fw fa-star l-margin-right--sm"/>{blapp.format.formatNumber(this.state.modelData.nLikesCnt)} likes
						</div>
						<div className="studio-model__meta-stat-social" data-ts-name="studio-model__meta--comments">
							<i className="far fa-fw fa-comments l-margin-right--sm"/>{blapp.format.formatNumber(this.state.modelData.nCommentsCnt)} comments
						</div>
					</section>
					<section className="studio-model__report">
						<DSAReportButton reportArea="StudioGallery" contentType="MOC" contentId={this.state.modelData.idModel} contentUrl="self">Report this design</DSAReportButton>
					</section>
				</section>
			</div>
		);
	}

	renderSharingStatus() {
		const {pendingModeration, hasFullAccess, hasFullAccessWithDownload, isDisplayOnly, isPrivate, isForcedPrivate} = this.returnStatusType();
		const isOwner = blapp.session.getUserID() == this.state.modelData.dmUserBuilder.dmUser.idUser;
		
		let statusContent = {type: '', title: '', description: ''};

		if(isForcedPrivate) {
			statusContent = {type: 'private', title: 'Your design was Forced Private.', description: 'Easy Buy, Wanted List, Studio file, and Instructions are only available to you and not accessible to the public.'};
		}else if(isPrivate) {
	 		statusContent = {type: 'private', title: 'Your design is set to Private.', description: 'Easy Buy, Wanted List, Studio file, and Instructions are only available to you and not accessible to the public.'};
		}else if(isDisplayOnly) {
			if(isOwner) {
				statusContent = {type: 'display', title: 'Your design is set to Display.', description: 'Easy Buy, Wanted List, Studio file, and Instructions are only available to you and not accessible to the public.'};
			}else{
				statusContent = {type: 'display', title: 'This design is for Display only.', description: 'Features are not accessible.'};
			}
		}else if(hasFullAccessWithDownload) {
			if(isOwner && pendingModeration) {
				statusContent = {type: 'display', title: 'Your design is currently set to Full Access and awaiting approval.', description: 'Easy Buy, Wanted List, Instructions, and Studio file will be disabled for the public until your design is approved by Admin.'};
			}else if(pendingModeration) {
				statusContent = {type: 'display', title: 'This design is currently in review.', description: 'Easy Buy, Wanted List, Instructions, and Studio file are disabled until the design is approved by Admin.'};
			}else if(isOwner){
				statusContent = {type: 'full-access-download', title: 'Your design is currently set to Full Access (with downloads).', description: null};
			}else{
				statusContent = null;
			}
		}else if(hasFullAccess) {
			if(isOwner && pendingModeration) {
				statusContent = {type: 'display', title: 'Your design is currently set to Full Access and awaiting approval.', description: 'Easy Buy, Wanted List, Instructions, and Studio file will be disabled for the public until your design is approved by Admin.'};
			}else if(pendingModeration) {
				statusContent = {type: 'display', title: 'This design is currently in review.', description: 'Easy Buy, Wanted List, Instructions, and Studio file are disabled until the design is approved by Admin.'};
			}else if(isOwner) {
				statusContent = {type: 'full-access', title: 'Your design is currently set to Full Access (without downloads).', description: 'Studio file is only accessible to you and is not viewable to the public.'};
			}else{
				statusContent = null;
			}
		}

		if(statusContent != null) {
			return (
				<article className={`studio-model__meta-block studio-model__sharing-status studio-model__sharing-status--${statusContent.type}`} data-ts-name="studio-model__sharing-status">
					<div className="studio-model__sharing-status-icon">
						<img className="studio-model__sharing-status-icon-item" src={`//${blapp.config.getHost( "static2" )}/img/studio-upload/moc-sharing--${statusContent.type}.svg`}/>
					</div>
					<h2 className="studio-model__sharing-status-title">{statusContent.title}</h2>
					{statusContent.description && <p className="studio-model__sharing-status-description">{statusContent.description}</p>}
				</article>
			);
		}
	}


	renderAward() {
		const award 					= this.state.modelData.nTypeBadge;
		const event 					= this.state.modelData.listEventBadges ? this.state.modelData.listEventBadges[0] : false;
		const pastDate				= this.getLastWeek().getTime();
		const staffPickAward 	= 
				(this.state.modelData.bStaffPicked &&  this.state.modelData.udtStaffPicked >= pastDate) ? 5 
			: (this.state.modelData.bStaffPicked && this.state.modelData.udtStaffPicked < pastDate) ? 4 : null;

		const selectedAward 			= StudioAwards(award);
		const selectedStaffAward 	= StudioAwards(staffPickAward);
		const eventAward 					= StudioEvents(event);

		let awards = [];

		if(selectedAward) {
			awards.push(this.returnAwardBlock(selectedAward));
		}

		if(selectedStaffAward) {
			awards.push(this.returnAwardBlock(selectedStaffAward));
		}

		if(eventAward) {
			awards.push(this.returnAwardBlock(eventAward));
		}

		if(awards.length > 2) {
			const pagination = awards.map((award, key) => {
				return (
					<li key={key} className={`${this.state.activeAward == key ? 'slick-active' : ''}`}>
						<button onClick={() => this.changeAward(key)}></button>
					</li>
				);
			});

			return (
				<div className="studio-model__meta-block studio-awards-slider" data-ts-name="studio-model__awards-group">
					<Slider className="studio-awards-slider__slider slick-slider--adaptive" ref={slider => this.slider = slider} {...this.slickSettings}>
						{awards}
					</Slider>
					<ul className="studio-awards-slider__pagination slick-dots" data-ts-name="studio-model__awards-group-pagination">
						{pagination}
					</ul>
				</div>
			);
		}else{
			return awards;
		}
	}

	changeAward(key) {
		this.setState({activeAward: key}, this.slider.slickGoTo(key));
	}

	returnAwardBlock(award) {
		return (
			<div key={award.slug} className="studio-model__meta-block studio-model__meta-block--award" data-ts-name="studio-model__award">
				<div style={{backgroundColor: award.strIconsConfig ? JSON.parse(award.strIconsConfig).bgColor : null}} className={`vertical-ribbon award-ribbon award-ribbon--${award.strWebSlug ? award.strWebSlug : award.slug} ${award.type ? `award-ribbon--type-${award.type}`: ''}`}>
					<AwardIcon award={award} classes="vertical-ribbon__icon"/>
				</div>
				<div>
					<p className="text--uppercase">{award.intro}</p>
					<h3 className="section-title">{award.content}</h3>
				</div>
			</div>
		);
	}

	renderDetails() {
		const pendingModeration = this.state.modelData.nModerateAction == 0 && this.state.modelData.nPreviousAccess != 0;
		const isOwner = blapp.session.getUserID() == this.state.modelData.dmUserBuilder.dmUser.idUser;
		
		return (
			<section className="studio-model__details">
				{(this.state.modelData.bShowPartList && !pendingModeration) || isOwner ?
					<ul className="view-selector view-selector--bordered l-border-top--null l-margin-bottom">
						<li className={"view-selector__item text-color--darkestBlue" + (this.state.detailView == 0 ? ' view-selector__item--active' : '')} data-ts-name="studio-model__details-tab--description" onClick={this.state.detailView != 0 ? () => this.setState({detailView: 0}) : null}>
							<span className="view-selector__item-content">{$T("DESCRIPTION")}</span>
						</li>
						
						<li className={"view-selector__item text-color--darkestBlue" + (this.state.detailView == 1 ? ' view-selector__item--active' : '')} data-ts-name="studio-model__details-tab--parts-list" onClick={this.state.detailView != 1 ? () => this.setState({detailView: 1}) : null}>
							<span className="view-selector__item-content">{$T("PARTS_LIST")}</span>
						</li>
					</ul>
					:
					<h3 className="section-title l-margin-bottom l-margin-top--xl">Description</h3>
				}
				{this.state.detailView == 0 ? this.renderContents() : this.renderPartsList()}
			</section>
		);
	}

	renderContents() {
		const contents = this.state.modelData.arrContents.map((content) => {
			switch(content.nContentType) {
				case 1: //description
					return (
						<div className="studio-model__content-block studio-model__content-block--details" key={content.nSortOrder}>
							<div dangerouslySetInnerHTML={{__html: content.strDescription}}/>
						</div>
					);

				case 2: //image
					const image = content.dmContentImage ? content.dmContentImage.url : content.dmTempFile ? content.dmTempFile.url : null;

					return(
						image ?
							<div className="studio-model__content-block studio-model__content-block--image" key={content.nSortOrder}>
								<img src={image}/>
							</div>
						: null
					);

				case 3: //video
					return (
						<div className="studio-model__content-block studio-model__content-block--video" key={content.nSortOrder}>
							<VideoContent url={content.strVideoUrl}/>
						</div>
					);
			}
		});

		return contents
	}

	renderPartsList() {
		const parts 						= 	this.state.modelData.arrParts;
		const partsItems 				= 	parts.filter(this.filterByColor).sort(this.sortFunction()).map((part) => <PartListingItem data={{image: blapp.url2.getCatalogItemImgUrl(part.dmItem.dmImg), name: part.dmItem.dmItem.strItemName, itemNumber: part.dmItem.dmItem.strItemNoFull, qty: part.nQty, color: part.dmItem.idColor}} key={`${part.dmItem.dmItem.idItem}-${part.dmItem.idColor}`}/>);
		const customParts 			=	this.state.modelData.arrCustomParts.length;
		const customPartsItems 	= 	this.state.modelData.arrCustomParts.filter(this.filterByColorCustomPart).map((part) => <PartListingItem data={{image: blapp.url2.getCatalogItemImgUrl(null), name: part.strDescription, qty: part.nQty, color: part.idColor}} key={`${part.strDescription}-${part.idColor}`}/>);
		const uniqueColors			= 	this.returnUniqueColors();
		const colors 						= 	uniqueColors.map((color, key) => {
			let selectedColor = blapp.color.get(color);

			if(selectedColor == null) {
				selectedColor = blapp.color.get(0);
			}

			return (
				<div key={key} className="l-flex l-center l-full-width"><i className="color-swatch color-swatch--small l-margin-right--sm" style={{background: `#${selectedColor.strColorHex}`}}/><span className="overflow-ellipsis">{selectedColor.strColorName}</span></div>
			);
		});

		const allColors 		=	(<div className="l-flex l-center l-full-width"><ColorWheel classes="l-margin-right--sm"/><span className="overflow-ellipsis">{$T("ALL_COLORS")}</span></div>);
		const colorIdx 			= uniqueColors.findIndex(idColor => idColor == this.state.filterColor);

		return (
			<div className="studio-model__parts-content">
				<div className="studio-model__parts-actions">
					<button className="btn studio-model__parts-actions-item studio-model__parts-actions-item--wanted" data-ts-name="studio-model__parts-add-to-wanted" onClick={() => this.showWantedListModal()}><i className="far fa-fw fa-heart l-margin-right--sm"/>Add parts to Wanted List</button>
					<CustomSelect classes="studio-model__parts-actions-item studio-model__parts-actions-item--colors" selectedIdx={colorIdx < 0 ? 0 : (colorIdx+1)} items={[allColors, ...colors]} tight={true} onChangeFunc={(c) => {c==0 ? this.selectColor(0) : this.selectColor(uniqueColors[c-1])}}/>
					<div className="sort-lockup studio-model__parts-actions-item studio-model__parts-actions-item--sort">
						<button className="btn sort-lockup__direction" data-ts-name="studio-model__parts-sort-direction" onClick={() => this.setState({sortDirection: this.state.sortDirection == -1 ? 1 : -1})}><i className={"fas " + (this.state.sortDirection == -1 ? 'fa-sort-amount-down' : 'fa-sort-amount-up')}/></button>
						<select className="select sort-lockup__select" data-ts-name="studio-model__parts-sort-select" value={this.state.sort} onChange={(e) => this.setState({sort: parseInt(e.target.value)})}>
							<option value={0}>{$T("COLOR_ITEM")}</option>
							<option value={1}>{$T("ITEM_COLOR")}</option>
							<option value={2}>{$T("ITEM_NO")}</option>
							<option value={3}>{$T("QUANTITY")}</option>
						</select>
					</div>
				</div>
				{customParts > 0 ? <div className="studio-model__custom-parts-header">Official LEGO parts</div> : null}
				<div className="studio-model__parts-header">
					<strong className="studio-model__parts-header-name">{$T("NAME")}</strong>
					<strong className="studio-model__parts-header-qty">{$T("QUANTITY")}</strong>
				</div>
				{partsItems}
				{customParts > 0 ?
					<React.Fragment>
						<div className="studio-model__custom-parts-header">Designer's custom parts</div>
						<div className="studio-model__parts-header">
							<strong className="studio-model__parts-header-name">{$T("NAME")}</strong>
							<strong className="studio-model__parts-header-qty">{$T("QUANTITY")}</strong>
						</div>
						{customPartsItems}
					</React.Fragment>
				: null}
			</div>
		);
	}

	renderTags() {
		const tags 			= this.state.modelData.arrTags;
		const tagItems 	= tags.map((tag, key) => <li key={key} className={`studio-model__tag-item pill pill--round l-margin--sm ${!this.preview ? ' pill--clickable' : ''}`} data-ts-name="studio-model__tag"><button className="btn btn--blank" onClick={!this.preview ? () => {this.setState({selectedTag: tag} ,() => {this.props.func.setSearch(tag);this.closeModal()})} : null}>{tag}</button></li>);

		return (
			<section className="studio-model__tags">
				<h3 className="section-title l-margin-bottom">{$T("TAGS")}</h3>
				<ul className="studio-model__tags-list">
					{tagItems}
				</ul>
			</section>
		);
	}

	renderComments() {
		return (
			<section className="studio-model__comments l-margin-bottom--xl" data-ts-name="studio-model__comments">
				<h2 className="section-title l-margin-bottom">{$T("LEAVE_COMMENT")}</h2>
				<CommentsSection reportArea={"StudioGallery"} item={{idItem: this.props.idModel, idUserBuilder: this.state.modelData.dmUserBuilder.dmUser.idUser}} mode={1} noReview={true} noInstructions={true} loginModalOnly/>
			</section>
		);
	}

	returnUniqueColors() {
		const inventory = this.state.modelData.arrParts;
		const colors 	= [];

		inventory.forEach(item => {
			if(colors.indexOf(item.dmItem.idColor) == -1) { 
				colors.push(item.dmItem.idColor);
			}
		});

		if(this.state.modelData.arrCustomParts.length > 0) {
			const customPartsInventory = this.state.modelData.arrCustomParts;

			customPartsInventory.forEach(item => {
				if (colors.indexOf(item.idColor) == -1) {
					colors.push(item.idColor);
				}
			});
		}
		

		return colors;
	}

	downloadModel() {
		const me = blapp.session.getMe();
		
		if(me == null) {
			blapp.refs.get("header").showLogin(() => {	
				if(blapp.session.isLoggedIn()) {
					window.open(blapp.url2.getStudioFileUrl(this.props.idModel));
				}	
			}, 'onlymodal');
			return;
		}else{
			window.open(blapp.url2.getStudioFileUrl(this.props.idModel));
		}
	}

	fetchPersonalizeData() {
		this._callbackRegistered	= this.updatePersonalizedData;
		blapp.personalized.fetchPersonalizedDataForModel( this.props.idModel, this.updatePersonalizedData );
	}

	updatePersonalizedData = (data) => {
		if(data && data.dataModel) {
			const likes = update(this.state.likes, {liked: {$set: data.dataModel.bIsLiked}});
			this.setState({likes: likes});
		}
	}

	selectColor(c) {
		this.setState({filterColor: c})
	}

	filterByColor = (item) => {
		if(this.state.filterColor == 0 || this.state.filterColor == item.dmItem.idColor) {
			return true
		}

		return false;
	}

	filterByColorCustomPart = (item) => {
		if(this.state.filterColor == 0 || this.state.filterColor == item.idColor) {
			return true
		}

		return false;
	}

	sortFunction = (l,r) => {
		let sortType 		= this.state.sort;
		let sortDirection 	= this.state.sortDirection;

		if(sortType === 0) { //Color, Item No
			return (a, b) => {
				if(blapp.color.get(a.dmItem.idColor == -1 ? 0 : a.dmItem.idColor).strColorName < blapp.color.get(b.dmItem.idColor == -1 ? 0 : b.dmItem.idColor).strColorName) {
					return -1 * sortDirection;
				}else if (blapp.color.get(a.dmItem.idColor == -1 ? 0 : a.dmItem.idColor).strColorName > blapp.color.get(b.dmItem.idColor == -1 ? 0 : b.dmItem.idColor).strColorName) {
					return 1 * sortDirection;
				}else if (a.dmItem.dmItem.strItemNo < b.dmItem.dmItem.strItemNo) {
					return -1 * sortDirection;
				}else if(a.dmItem.dmItem.strItemNo > b.dmItem.dmItem.strItemNo) {
					return 1 * sortDirection;
				}

				return 0;
			}
		}else if(sortType === 1) { //Item name, color
			return (a, b) => {
				if(a.dmItem.dmItem.strItemName.toLowerCase() < b.dmItem.dmItem.strItemName.toLowerCase()) {
					return -1 * sortDirection;
				}	else if(a.dmItem.dmItem.strItemName.toLowerCase() > b.dmItem.dmItem.strItemName.toLowerCase()) {
					return 1 * sortDirection;
				}else if(blapp.color.get(a.dmItem.idColor == -1 ? 0 : a.dmItem.idColor).strColorName < blapp.color.get(b.dmItem.idColor == -1 ? 0 : b.dmItem.idColor).strColorName) {
					return -1 * sortDirection;
				}else if(blapp.color.get(a.dmItem.idColor == -1 ? 0 : a.dmItem.idColor).strColorName > blapp.color.get(b.dmItem.idColor == -1 ? 0 : b.dmItem.idColor).strColorName) {
					return 1 * sortDirection;
				}

				return 0;
			}
		}else if(sortType === 2) { 	//ITEM_NO
			return (a, b) => {
				if(a.dmItem.dmItem.strItemNo < b.dmItem.dmItem.strItemNo) {
					return -1 * sortDirection;
				}else if(a.dmItem.dmItem.strItemNo > b.dmItem.dmItem.strItemNo) {
					return 1 * sortDirection;
				}

				return 0;
			}
		}else if(sortType === 3) {	//Quantity
			return(a, b) => {
				if(a.nQty < b.nQty) {
					return -1 * sortDirection;
				}else if(a.nQty > b.nQty) {
					return 1 * sortDirection;
				}

				return 0;
			}
		}
	}

	showWantedListModal() {	
		const me = blapp.session.getMe();

		if(me == null) {
			blapp.refs.get("header").showLogin(() => {
				if(blapp.session.isLoggedIn()) {
					this.setState({showAddToWLModal: true})
				}
			}, 'onlymodal');

			return;
		}else{
			this.setState({showAddToWLModal: true})
		}
	}

	addToWantedList() {
		let bPrivate = this.state.modelData.statusModel != 1;
		let bDownloadable = this.state.modelData.bDownloadable;

		let addItems = [];
		let smi	=	{ 
								location:	blapp.srcmap.LOCATION.MS_DETAIL
							,	typeSrcFrom: blapp.srcmap.SRCTYPE.STUDIO_MODEL
							,	idSrcFrom: this.props.idModel
							,	extra: bPrivate ? 1 : bDownloadable ? 3 : 2
							};
		let uploadFrom	= -1;

		_.forEach(this.state.modelData.arrParts, (part) => {
			addItems.push(
				{
					dmItemImage:	part.dmItem
				,	bNotify:		false
				,	idWantedItem:	null
				,	mMaxPrice:		0
				,	nHaveQty:		0
				,	nWantedColorId:	part.dmItem.idColor
				,	nWantedQty:		part.nQty
				,	strCondition:	"X"
				,	strRemarks:		"Added from model " + this.state.modelData.strModelName
				}						
			);
		});

		if(this.state.modelData.nUploadedFrom) {
			switch(this.state.modelData.nUploadedFrom) {
				case 0:		// From Studio
					uploadFrom	= 3;
					break;

				case 1:		// From Web
					uploadFrom	= 4;
					break;

				case 2:		// From Mosaick	-- Deprecated
					uploadFrom	= 21;
					break;
			}
		}

		return 	<AddToWantedListModal
					data={addItems}
					func={{toggleModal: () => this.setState({showAddToWLModal: false})}} 
					srcmap={smi}
					uploadFrom={uploadFrom}
					customParts={this.state.modelData.arrCustomParts.length}
				/>
	}

	triggerAlert(message) {
		const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom"></i>
		<p class="text-color--primaryRed">${message}</p>`;

		CustomAlert(confirmContent);
	}

	toggleLike() {
		const me = blapp.session.getMe();

		if(me == null) {
			blapp.refs.get("header").showLogin(() => {
				if(blapp.session.isLoggedIn()) {
					this.doToggleLike();
				}
			}, 'onlymodal');

			return;
		}
		else{
			this.doToggleLike();
		}
	}

	doToggleLike() {
		const likes = this.state.likes;

		blapp.models.fetch("_toggleLike",	{
				controller:	"studio.BLCUserModel"
			,	method:		"toggleLike"
			,	params:		[this.props.idModel]
			,	refresh:	true
		}).then((data) => {
			if(data !== null) {
				likes.liked = data;
				if(data == 0) {
					--likes.count
				}else{
					++likes.count; 
				}

				this.setState({likes: likes});
			}else{
				this.triggerAlert('Error performing action');
			}
    }).catch(() => {
			this.triggerAlert('Error performing action');
    });
	}

	closeModal() {
		if(this._historyPushed) {
			window.history.back();
		}else{
			if(this.state.selectedTag != null) {
				window.location.href = `${blapp.url2.getStudioGalleryUrl()}?s=${this.state.selectedTag}`;
			}else{
				window.location.href = blapp.url2.getStudioGalleryUrl();
			}
		}
	}

	onPopState(e) {
		document.title = this._previousTitle;
		this.props.close();
	}

	triggerModelViewer(method) {
		if(!this.MViewerNotSupport) {
			this.setState({showModelViewer: true, modelViewerMethod: method});
			this.incrementCounter(this.props.idModel, method);
		}else{
			this.triggerAlert('Model viewer is not suported by your browser');
		}
	}

	closeModelViewerModal = () => {
		this.setState({showModelViewer: false});
	}

	getModelData(idModel) {
		const likes = this.state.likes;

		blapp.models.fetch("_loadModelDetail", {
				controller:	"studio.BLCUserModel"
			,	method:		"getModelDetail"
			,	params:		[ idModel, true ]
			,	refresh:	true
		}).then((data) => {
			if(data !== null) {
				likes.count = data.nLikesCnt;
				this.setState({modelData: data, likes: likes}, () => this.fetchPersonalizeData());

				if(this._historyPushed){
					window.history.replaceState(history.state, data.strModelName + " from BrickLink Studio", null);
					document.title = data.strModelName + " from BrickLink Studio";
				}
			}else{
				this.setState({validModel: false});
			}
		}).catch((err) => {
			console.log(err)
			this.setState({validModel: false});
		});
	}

	incrementCounter(idModel, method) {
		blapp.models.fetch("_incrementModelCounters",	{
				controller:	"studio.BLCUserModel"
			,	method:		method =="steps" ? "incrementStepCnt" : "increment3DCnt"
			,	params:		[ idModel ]
			,	refresh:	true
		});

		let status = this.state.modelData.statusModel == 2 ? "1" : this.state.modelData.bDownloadable ? "3" : "2";
		blapp.track.trackGeneral(10075, method =="steps" ? "3" : "2", status, 1);
	}

	getLastWeek() {
		const today 		= new Date();
		const lastWeek 	= new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
		
		return lastWeek;
  }

	renderEasyBuy() {
		let	items	=	[];
		let smi		= { 
								location:		blapp.srcmap.LOCATION.MS_DETAIL
							,	typeSrcFrom:	blapp.srcmap.SRCTYPE.STUDIO_MODEL
							,	idSrcFrom:		this.props.idModel
							};

		_.forEach(this.state.modelData.arrParts, (part, idx) => {
			items.push({
					keyFind:	idx
				,	idItem:		part.dmItem.dmItem.idItem
				,	idColor:	part.dmItem.idColor
				,	nQty:		part.nQty
				,	bMandatory:	false
				,	condNew:	"X"
				,	bSealed:	false
				});
			}
		);		

		let uploadFrom	= 0;

		switch(this.state.modelData.nUploadedFrom) {
			case 0:	uploadFrom	= 11;	break;	// From Studio
			case 1:	uploadFrom	= 13;	break;	// From Web
			case 2:	uploadFrom	= 26;	break;	// From Mosaic
		}

		return (
			<EasyBuyModal 
				origin="gallery"
				originName={this.state.modelData.strModelName}
				referID={this.state.modelData.idModel}
				uploadFrom={uploadFrom}
				itemsToBuy={ items }
				findOption={{op_only: true}}
				toggleModal={()=>this.setState({ showEasyBuyModal: false })}
				srcMap={smi}
				customParts={this.state.modelData.arrCustomParts.length}
			/>			
		);
	}
};

var $T = BLComponent.createTextMap( 
		{
			"STUDIO_GALLERY":
			{
				"en":	"Studio Gallery"
			,	"kr":	""
			,	"es":	"Galería"
			}
		,	"PUBLISHED":
			{
				"en":	"Published",
				"kr":	"",
				"es":	"Publicado"
			}
		,	"LOTS":
			{
				"en":	"Lots",
				"kr":	"",
				"es":	"Lotes"
			}
		,	"ITEMS":
			{
				"en":	"Items",
				"kr":	"",
				"es":	"Elementos"
			}
		,	"COLORS":
			{
				"en":	"Colors",
				"kr":	"",
				"es":	"Colores"
			}
		,	"FOR_DISPLAY_ONLY":
			{
				"en":	"For display only",
				"kr":	"",
				"es":	"Sólo para visualizar"
			}
		,	"DOWNLOAD_FILE":
			{
				"en":	"Download Studio file",
				"kr":	"",
				"es":	"Descargar archivo de Studio"
			}
		,	"EASY_BUY":
			{
				"en":	"Easy Buy",
				"kr":	"",
				"es":	"Easy Buy"
			}
		,	"BUILDING_STEPS":
			{
				"en":	"Building steps",
				"kr":	"",
				"es":	"Pasos"
			}
		,	"3D_MODEL":
			{
				"en":	"3D model",
				"kr":	"",
				"es":	"Modelo 3D"
			}
		,	"DESCRIPTION":
			{
				"en":	"Description",
				"kr":	"",
				"es":	"Descripción"
			}
		,	"PARTS_LIST":
			{
				"en":	"Parts list",
				"kr":	"",
				"es":	"Lista de partes"
			}
		,	"ALL_COLORS":
			{
				"en":	"All colors",
				"kr":	"",
				"es":	"Todos los colores"
			}
		,	"ADD_WANTED_LIST":
			{
				"en":	"Add to Wanted List",
				"kr":	"",
				"es":	"Añadir partes a lista de deseo"
			}
		,	"NAME":
			{
				"en":	"Name",
				"kr":	"",
				"es":	"Nombre"
			}
		,	"QUANTITY":
			{
				"en":	"Quantity",
				"kr":	"",
				"es":	"Cantidad"
			}
		,	"COLOR_ITEM":
			{
				"en":	"Color name, item no",
				"kr":	"",
				"es":	"Color, item no"
			}
		,	"ITEM_COLOR":
			{
				"en":	"Item name, color",
				"kr":	"",
				"es":	"Nombre, color"
			}
		,	"ITEM_NO":
			{
				"en":	"Item no",
				"kr":	"",
				"es":	"Item no"
			}
		,	"TAGS":
			{
				"en":	"Tags",
				"kr":	"",
				"es":	"Etiquetas"
			}
		,	"LEAVE_COMMENT":
			{
				"en":	"Leave a comment",
				"kr":	"",
				"es":	""
			}
	}
);
 

